// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-tooltip {
  position: absolute;
  background: var(--surface-primary);
  padding: 12px;
  border-radius: 8px;
  font-size: 12px;
  white-space: nowrap;
  text-align: left;
  min-width: 150px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid var(--border-primary);
  line-height: 1.4;
  backdrop-filter: blur(10px);
  max-width: 240px;
}

.tooltip-ticker {
  font-size: 14px;
  color: var(--text-primary);
  margin-bottom: 2px;
}

.tooltip-company {
  font-size: 12px;
  color: var(--text-primary);
  margin-bottom: 2px;
  white-space: wrap;
}

.tooltip-industry {
  font-size: 10px;
  color: var(--text-secondary);
  margin-bottom: 8px;
}
.tooltip-separator {
  height: 8px;
  margin: 4px 0px;
  margin-top: 8px;
  border-top: 1px dotted var(--border-primary);
}

.tooltip-metric {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  font-size: 11px;
  text-align: right;
  color: var(--text-primary);
}

.tooltip-metric.positive {
  color: var(--text-up-color);
}

.tooltip-metric.negative {
  color: var(--text-down-color);
}

.tooltip-metric-label {
  display: inline-block;
  width: 60px;
  text-align: left;
  font-weight: bold;
  color: var(--text-secondary);
}
.tooltip-metric-label-right {
  width: 100%;
  text-align: right;
}

.tooltip-loading-spinner {
  display: inline-block;
  width: 10px;
  height: 10px;
  border: 1.5px solid var(--border-primary);
  border-top-color: var(--text-secondary);
  border-radius: 50%;
  vertical-align: middle;
  animation: tooltip-loading-spin 0.6s linear infinite;
}

@keyframes tooltip-loading-spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Heatmap/Tooltip.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,uCAAuC;EACvC,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,uCAAuC;EACvC,kBAAkB;EAClB,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".stock-tooltip {\n  position: absolute;\n  background: var(--surface-primary);\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 12px;\n  white-space: nowrap;\n  text-align: left;\n  min-width: 150px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border: 1px solid var(--border-primary);\n  line-height: 1.4;\n  backdrop-filter: blur(10px);\n  max-width: 240px;\n}\n\n.tooltip-ticker {\n  font-size: 14px;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n}\n\n.tooltip-company {\n  font-size: 12px;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n  white-space: wrap;\n}\n\n.tooltip-industry {\n  font-size: 10px;\n  color: var(--text-secondary);\n  margin-bottom: 8px;\n}\n.tooltip-separator {\n  height: 8px;\n  margin: 4px 0px;\n  margin-top: 8px;\n  border-top: 1px dotted var(--border-primary);\n}\n\n.tooltip-metric {\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n  font-size: 11px;\n  text-align: right;\n  color: var(--text-primary);\n}\n\n.tooltip-metric.positive {\n  color: var(--text-up-color);\n}\n\n.tooltip-metric.negative {\n  color: var(--text-down-color);\n}\n\n.tooltip-metric-label {\n  display: inline-block;\n  width: 60px;\n  text-align: left;\n  font-weight: bold;\n  color: var(--text-secondary);\n}\n.tooltip-metric-label-right {\n  width: 100%;\n  text-align: right;\n}\n\n.tooltip-loading-spinner {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border: 1.5px solid var(--border-primary);\n  border-top-color: var(--text-secondary);\n  border-radius: 50%;\n  vertical-align: middle;\n  animation: tooltip-loading-spin 0.6s linear infinite;\n}\n\n@keyframes tooltip-loading-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
